module.exports = __webpack_public_path__ + "assets/kafeibei.30b22bd1.svg";